// Cap a (already-formatted) category-axis label so a rotated, all-categories
// x-axis stays readable instead of running off the canvas. The full value still
// shows in the tooltip, so a trailing ellipsis is purely cosmetic. Composes on
// top of `makeCategoryFormatter` output — we truncate the localized string, not
// the raw cell.
const MAX_TICK_CHARS = 18;

export function truncateTick(label: string, max = MAX_TICK_CHARS): string {
  if (label.length <= max) return label;
  // Trim trailing whitespace the cut may expose, then append an ellipsis.
  return `${label.slice(0, max).trimEnd()}…`;
}
